'use strict';

/**
 * module
 */
import { tab } from './module/_tab';

/**
 * news
 */
const news = (() => {
    const init = () => {
        tab.init();
    };

    // public
    return {
        init: init
    };
})();

$(() => {
    news.init();
});
